import { createSlice } from "@reduxjs/toolkit";

export const UserAccountTypeSlice = createSlice({
    name: "userAccountType",
    initialState: {
        userAccountType: null,
    },
    reducers: {
        setUserAccountType: (state, action) => {
            state.userAccountType = action.payload;
        },
    }
})

export const { setUserAccountType } = UserAccountTypeSlice.actions;

export default UserAccountTypeSlice.reducer;